export default "__VITE_ASSET__Ckb5LYqr__"